import API from '@aws-amplify/api';
import { dummySearchResponse, dummySearchResponseNothing } from '../dummy/searchResponse';

const SEARCH_DEBUG = false;
const SEARCH_DEBUG_NOTHING = false;

/**
 * Lookup a product handle from the variant SKU
 * @param variantSKU
 * @returns
 */
export const getShopifyProxyProductHandleBySKU = async (variantSKU: string): Promise<string | undefined> => {
  return API.get('shopifyproxy', '/productHandleBySKU/' + variantSKU, {}).then((response) => {
    return response.data;
  });
};

/**
 * Use the shopifyproxy to get search results
 * @param query
 * @returns
 */
export const getShopifyProxySiteSearchResults = async (query: string) => {
  if (SEARCH_DEBUG_NOTHING) return Promise.resolve(dummySearchResponseNothing);
  if (SEARCH_DEBUG) return Promise.resolve(dummySearchResponse);
  return API.get('shopifyproxy', '/search/' + query, {});
};

/**
 * Lookup product tags
 * @param
 * @returns
 */
export const getShopifyProxyProductTags = async (): Promise<string | undefined> => {
  return API.get('shopifyproxy', '/productTags', {}).then((response) => {
    return response.data;
  });
};
